import { getVehicleEquipment } from '../../server/api/mappers/vehicles.helpers';

/**
 * Lamborghini
 *
 * ```
 *     State:   For Sale - Sale active
 *    Images:   Yes
 *      Bids:   4
 * User bids:   0
 *    Mapper:   No
 * ```
 */
export default () => {
	const vehicle = {
		additionalDetails: null,
		additionalSpec: 'Chilli pack, DAB Radio. Minimum. Bluetooth. Minimum 4mm tyre tread.',
		additionalSpecV2: {
			items: [
				{ name: 'Jet boosters', price: 0 },
				{ name: 'Mirror dice', price: 0 },
			],
			totalCost: 0,
		},
		availableFrom: null,
		availableUntil: null,
		bids: {
			activeBidCount: 4,
			usersBids: [],
		},
		dentsDesc: null,
		displayPrice: 160000,
		electricsProblemsDesc: '',
		equipment: 'sat_nav,heated_seats,parking_cam',
		exteriorGrade: 'gold',
		hasBeenSmokedIn: false,
		hasDents: false,
		hasElectricsProblems: false,
		hasLockingWheelNut: true,
		hasMissingParts: false,
		hasOtherContactActiveBid: false,
		hasPaintProblems: false,
		hasPrivatePlate: false,
		hasScratches: true,
		hasScuffedAlloy: true,
		hasServiceRecords: true,
		hasToolsInBoot: true,
		hasWarningLights: false,
		hasWindscreenProblems: false,
		id: 415389,
		independentServiceStampsCount: 0,
		interiorType: 'Leather',
		isTrade: false,
		isVatQualifying: null,
		isVehicleOnFinance: false,
		keeperStartDate: '2018-10-04T00:00:00.000Z',
		keysCount: 2,
		lastMOTDate: null,
		mileage: 2500,
		minimumBid: {
			type: 'bid',
			value: 10000,
		},
		missingPartsDesc: null,
		officialServiceStampsCount: 1,
		paintProblemsDesc: null,
		prettyVrm: 'LJ68 AXA',
		previousKeepersCount: null,
		scratchesDesc: 'scratchesDesc',
		scuffedAlloyDesc: 'x1 ',
		seller: {
			area: null,
			country: 'Northern Ireland',
			distance: 147,
			town: 'Merthyr Tydfil',
		},
		sellerWillAcceptPrice: 160000,
		serviceHistory: 'yes',
		soldDate: null,
		spec: {
			body: 'Coupe',
			bodyCategory: 'Coupe',
			colour: 'Green',
			engineSize: 5204,
			firstRegistered: '2018-10-04T00:00:00.000Z',
			fuel: 'Petrol',
			make: 'Lamborghini',
			model: 'Huracan',
			transmission: 'Semi-automatic',
			vin: 'ZHWEC12EXKLA11416',
		},
		state: {
			category: 'for_sale',
			id: 93,
			name: 'For sale - Sale active',
			slug: 'sale_active',
		},
		tyreProblemsDesc: null,
		vehicleImages: [
			{
				createdAt: '2020-06-17T15:30:47.197Z',
				enquiryId: 415389,
				id: 653686,
				kind: 'exterior_front_driver',
				meta: {
					canvas: {
						height: 548,
						left: 0,
						naturalHeight: 2160,
						naturalWidth: 2880,
						top: 0,
						width: 731,
					},
					cropBox: {
						height: 486,
						left: 37,
						top: 47,
						width: 649,
					},
					height: 1918,
					rotate: 0,
					scaleX: 1,
					scaleY: 1,
					width: 2556,
					x: 146,
					y: 184,
				},
				source: 'motorway-photos-webapp:395e43ac86c77481471af5e64daa58c65e14546a',
				url: 'https://motorway.imgix.net/5389/415389/415389-exterior_front_driver-1592407845459.jpeg',
			},
			{
				createdAt: '2020-06-17T15:31:02.310Z',
				enquiryId: 415389,
				id: 653688,
				kind: 'exterior_rear_driver',
				meta: {
					canvas: {
						height: 548,
						left: 0,
						naturalHeight: 2160,
						naturalWidth: 2880,
						top: 0,
						width: 731,
					},
					cropBox: {
						height: 438,
						left: 0,
						top: 110,
						width: 585,
					},
					height: 1728,
					rotate: 0,
					scaleX: 1,
					scaleY: 1,
					width: 2304,
					x: 0,
					y: 432,
				},
				source: 'motorway-photos-webapp:395e43ac86c77481471af5e64daa58c65e14546a',
				url: 'https://motorway.imgix.net/5389/415389/415389-exterior_rear_driver-1592407860456.jpeg',
			},
			{
				createdAt: '2020-06-23T14:49:02.613Z',
				enquiryId: 415389,
				id: 668518,
				kind: 'exterior_front_passenger',
				meta: {
					canvas: {
						height: 548,
						left: 0,
						naturalHeight: 1200,
						naturalWidth: 1600,
						top: 0,
						width: 731,
					},
					cropBox: {
						height: 438,
						left: 23,
						top: 110,
						width: 585,
					},
					height: 960,
					rotate: 0,
					scaleX: 1,
					scaleY: 1,
					width: 1280,
					x: 51,
					y: 240,
				},
				source: 'motorway-agent-webapp:b9f2f1d44ce0cd512568f1f33e0b78713c97ca1e',
				url: 'https://motorway.imgix.net/5389/415389/exterior_front_passenger-1592923742501.jpg',
			},
			{
				createdAt: '2020-06-17T15:31:15.473Z',
				enquiryId: 415389,
				id: 653690,
				kind: 'exterior_rear_passenger',
				meta: {
					canvas: {
						height: 548,
						left: 0,
						naturalHeight: 2160,
						naturalWidth: 2880,
						top: 0,
						width: 731,
					},
					cropBox: {
						height: 438,
						left: 73,
						top: 55,
						width: 585,
					},
					height: 1728,
					rotate: 0,
					scaleX: 1,
					scaleY: 1,
					width: 2304,
					x: 288,
					y: 216,
				},
				source: 'motorway-photos-webapp:395e43ac86c77481471af5e64daa58c65e14546a',
				url: 'https://motorway.imgix.net/5389/415389/415389-exterior_rear_passenger-1592407871968.jpeg',
			},
			{
				createdAt: '2020-06-17T15:33:08.319Z',
				enquiryId: 415389,
				id: 653704,
				kind: 'interior_front_seats',
				meta: {
					canvas: {
						height: 587,
						left: 0,
						naturalHeight: 2160,
						naturalWidth: 2880,
						top: 0,
						width: 783,
					},
					cropBox: {
						height: 543,
						left: 0,
						top: 0,
						width: 724,
					},
					height: 1997,
					rotate: 0,
					scaleX: 1,
					scaleY: 1,
					width: 2663,
					x: 0,
					y: 0,
				},
				source: 'motorway-photos-webapp:395e43ac86c77481471af5e64daa58c65e14546a',
				url: 'https://motorway.imgix.net/5389/415389/415389-interior_front_seats-1592407984230.jpeg',
			},
			{
				createdAt: '2020-06-23T14:52:25.468Z',
				enquiryId: 415389,
				id: 668547,
				kind: 'interior_rear_seats',
				meta: {
					canvas: {
						height: 381,
						left: 63,
						naturalHeight: 1600,
						naturalWidth: 1200,
						top: 84,
						width: 285,
					},
					cropBox: {
						height: 309,
						left: 0,
						top: 151,
						width: 412,
					},
					height: 1299,
					rotate: 0,
					scaleX: 1,
					scaleY: 1,
					width: 1732,
					x: 0,
					y: 282,
				},
				source: 'motorway-agent-webapp:b9f2f1d44ce0cd512568f1f33e0b78713c97ca1e',
				url: 'https://motorway.imgix.net/5389/415389/interior_rear_seats-1592923945409.jpg',
			},
			{
				createdAt: '2020-06-23T14:47:54.015Z',
				enquiryId: 415389,
				id: 668502,
				kind: 'interior_dashboard',
				meta: {
					canvas: {
						height: 548,
						left: 0,
						naturalHeight: 1200,
						naturalWidth: 1600,
						top: 0,
						width: 731,
					},
					cropBox: {
						height: 493,
						left: 73,
						top: 55,
						width: 658,
					},
					height: 1080,
					rotate: 0,
					scaleX: 1,
					scaleY: 1,
					width: 1440,
					x: 160,
					y: 120,
				},
				source: 'motorway-agent-webapp:b9f2f1d44ce0cd512568f1f33e0b78713c97ca1e',
				url: 'https://motorway.imgix.net/5389/415389/interior_dashboard-1592923673791.jpg',
			},
			{
				createdAt: '2020-06-23T14:47:38.482Z',
				enquiryId: 415389,
				id: 668498,
				kind: 'interior_boot',
				meta: {
					canvas: {
						height: 548,
						left: 1,
						naturalHeight: 1600,
						naturalWidth: 1200,
						top: 0,
						width: 411,
					},
					cropBox: {
						height: 309,
						left: 0,
						top: 239,
						width: 412,
					},
					height: 902,
					rotate: 0,
					scaleX: 1,
					scaleY: 1,
					width: 1202,
					x: 0,
					y: 698,
				},
				source: 'motorway-agent-webapp:b9f2f1d44ce0cd512568f1f33e0b78713c97ca1e',
				url: 'https://motorway.imgix.net/5389/415389/interior_boot-1592923658505.jpg',
			},
			{
				createdAt: '2020-06-17T15:31:51.270Z',
				enquiryId: 415389,
				id: 653695,
				kind: 'wheels_front_driver',
				meta: {
					canvas: {
						height: 846,
						left: -172,
						naturalHeight: 2160,
						naturalWidth: 2880,
						top: -129,
						width: 1128,
					},
					cropBox: {
						height: 470,
						left: 78,
						top: 59,
						width: 626,
					},
					height: 1200,
					rotate: 0,
					scaleX: 1,
					scaleY: 1,
					width: 1600,
					x: 640,
					y: 480,
				},
				source: 'motorway-photos-webapp:395e43ac86c77481471af5e64daa58c65e14546a',
				url: 'https://motorway.imgix.net/5389/415389/415389-wheels_front_driver-1592407908448.jpeg',
			},
			{
				createdAt: '2020-06-17T15:32:03.477Z',
				enquiryId: 415389,
				id: 653697,
				kind: 'wheels_rear_driver',
				meta: {
					canvas: {
						height: 846,
						left: -172,
						naturalHeight: 2160,
						naturalWidth: 2880,
						top: -129,
						width: 1128,
					},
					cropBox: {
						height: 470,
						left: 73,
						top: 42,
						width: 626,
					},
					height: 1200,
					rotate: 0,
					scaleX: 1,
					scaleY: 1,
					width: 1600,
					x: 627,
					y: 437,
				},
				source: 'motorway-photos-webapp:395e43ac86c77481471af5e64daa58c65e14546a',
				url: 'https://motorway.imgix.net/5389/415389/415389-wheels_rear_driver-1592407921973.jpeg',
			},
			{
				createdAt: '2020-06-23T14:47:08.688Z',
				enquiryId: 415389,
				id: 668488,
				kind: 'wheels_front_passenger',
				meta: {
					height: 900,
					rotate: 0,
					scaleX: 1,
					scaleY: 1,
					width: 1200,
					x: 0,
					y: 350,
				},
				source: 'motorway-agent-webapp:b9f2f1d44ce0cd512568f1f33e0b78713c97ca1e',
				url: 'https://motorway.imgix.net/5389/415389/wheels_front_passenger-1592923628708.jpg',
			},
			{
				createdAt: '2020-06-17T15:31:20.215Z',
				enquiryId: 415389,
				id: 653691,
				kind: 'wheels_rear_passenger',
				meta: {
					canvas: {
						height: 846,
						left: -172,
						naturalHeight: 2160,
						naturalWidth: 2880,
						top: -129,
						width: 1128,
					},
					cropBox: {
						height: 470,
						left: 77,
						top: 25,
						width: 626,
					},
					height: 1200,
					rotate: 0,
					scaleX: 1,
					scaleY: 1,
					width: 1600,
					x: 637,
					y: 393,
				},
				source: 'motorway-photos-webapp:395e43ac86c77481471af5e64daa58c65e14546a',
				url: 'https://motorway.imgix.net/5389/415389/415389-wheels_rear_passenger-1592407878652.jpeg',
			},
			{
				createdAt: '2020-06-17T15:31:55.803Z',
				enquiryId: 415389,
				id: 653696,
				kind: 'tyre_tread_front_driver',
				meta: {
					canvas: {
						height: 587,
						left: 0,
						naturalHeight: 2160,
						naturalWidth: 2880,
						top: 0,
						width: 783,
					},
					cropBox: {
						height: 533,
						left: 73,
						top: 55,
						width: 710,
					},
					height: 1959,
					rotate: 0,
					scaleX: 1,
					scaleY: 1,
					width: 2613,
					x: 267,
					y: 202,
				},
				source: 'motorway-photos-webapp:395e43ac86c77481471af5e64daa58c65e14546a',
				url: 'https://motorway.imgix.net/5389/415389/415389-tyre_tread_front_driver-1592407914574.jpeg',
			},
			{
				createdAt: '2020-06-17T15:32:09.843Z',
				enquiryId: 415389,
				id: 653700,
				kind: 'tyre_tread_rear_driver',
				meta: {
					height: 2160,
					rotate: 0,
					scaleX: 1,
					scaleY: 1,
					width: 2880,
					x: 0,
					y: 0,
				},
				source: 'motorway-photos-webapp:395e43ac86c77481471af5e64daa58c65e14546a',
				url: 'https://motorway.imgix.net/5389/415389/415389-tyre_tread_rear_driver-1592407928678.jpeg',
			},
			{
				createdAt: '2020-06-17T15:31:39.876Z',
				enquiryId: 415389,
				id: 653694,
				kind: 'tyre_tread_front_passenger',
				meta: {
					height: 2160,
					rotate: 0,
					scaleX: 1,
					scaleY: 1,
					width: 2880,
					x: 0,
					y: 0,
				},
				source: 'motorway-photos-webapp:395e43ac86c77481471af5e64daa58c65e14546a',
				url: 'https://motorway.imgix.net/5389/415389/415389-tyre_tread_front_passenger-1592407898367.jpeg',
			},
			{
				createdAt: '2020-06-17T15:31:26.957Z',
				enquiryId: 415389,
				id: 653692,
				kind: 'tyre_tread_rear_passenger',
				meta: {
					height: 2160,
					rotate: 0,
					scaleX: 1,
					scaleY: 1,
					width: 2880,
					x: 0,
					y: 0,
				},
				source: 'motorway-photos-webapp:395e43ac86c77481471af5e64daa58c65e14546a',
				url: 'https://motorway.imgix.net/5389/415389/415389-tyre_tread_rear_passenger-1592407885546.jpeg',
			},
			{
				createdAt: '2020-06-18T16:18:51.222Z',
				damageMeta: {
					overlayUrl:
						'https://motorway.s3.eu-west-2.amazonaws.com/photos-assets/vehicle_damage_overlays/suv_back_v1.png',
					side: 'back',
					size: 'large',
					x: '300',
					y: '200',
				},
				enquiryId: 415389,
				id: 656299,
				kind: 'damage_alloy_scuffs',
				meta: {
					height: '3024',
					rotate: '90',
					scaleX: '1',
					scaleY: '1',
					width: '4032',
					x: '0',
					y: '0',
				},
				source: 'motorway-seller-webapp:4e349a35e852fc18cd0e2a781bf277993416ffa2',
				url: 'https://motorway.imgix.net/5389/415389/damage_alloy_scuffs-1592497127162.jpg',
			},
		],
		vrm: 'LJ68AXA',
		warningLightsDesc: null,
		windscreenProblemsDesc: null,
		year: 2018,
	};

	return {
		...vehicle,
		equipmentV2: getVehicleEquipment(vehicle),
	};
};
